<template>
  <div>
    <v-app-bar app flat class="sv-toolbar">
      <v-app-bar-nav-icon @click.stop="onMinifySidebar" />
      <v-toolbar-title class="pl-1">
        <span
          v-for="(part, i) in pageTitlePath"
          :key="i"
          class="breadcrumb-folder"
        >
          <template v-if="part.link != null">
            <router-link :to="part.to">{{ part.title }}</router-link>
            /
          </template>
          <template v-else> {{ part.title }} / </template>
        </span>
        <span class="breadcrumb-workplace">{{ pageTitle.title }}</span>
      </v-toolbar-title>
      <v-spacer />
      <slot></slot>
      <toolbar-profile-menu />
      <slot name="append"></slot>
    </v-app-bar>
  </div>
</template>

<script>
import NotificationMixin from "./../../mixins/NotificationMixin";
import PermissionMixin from "./../../mixins/CheckPermissionMixin";
import ToolbarProfileMenu from "./ToolbarProfileMenu";
import { useMenuTree } from "@/use/MenuTree.js";

import "./Toolbar.scss";

export default {
  name: "Toolbar",
  components: {
    ToolbarProfileMenu
  },
  mixins: [NotificationMixin, PermissionMixin],
  data() {
    return {
      responsive: false,
      responsiveInput: false,
      dummyVal: "< без заголовка >"
    };
  },
  computed: {
    nodeLang() {
      return this.$store.getters.getLang;
    },
    currentNode() {
      return this.$store.getters.getCurrentNode(this.$route.params.id);
    },
    currentNodePathTitles() {
      // < без заголовка >
      if (!this.currentNode) return [];
      const parentEntries = this.currentNode.p.map(parent => ({
        title: parent.t[this.nodeLang] || parent.t[""] || this.dummyVal,
        to: {
          name: "NodeChildren",
          params: { id: parent.id }
        },
        link: true
      }));
      return [
        ...parentEntries,
        {
          title:
            this.currentNode.t[this.nodeLang] ||
            this.currentNode.t[""] ||
            this.dummyVal,
          to: {
            name: "NodeChildren",
            params: { id: this.currentNode.id }
          },
          link: true
        }
      ];
    },
    currentPathTitles() {
      // заголовок для страницы редактирования QR-кода
      if (["QrGiftsEdit", "QrGiftsView"].includes(this.$route.name)) {
        const title = this.currentNode?.t?.[this.nodeLang] || "QR-сувенир";
        return [
          { link: true, title: "QR-сувениры", to: { name: "QrGifts" } },
          { link: false, title }
        ];
        // заголовок для страницы редактирования CRM-контакта
      } else if (
        ["CrmContactsEdit", "CrmContactsView"].includes(this.$route.name)
      ) {
        const title = this.currentNode?.t?.[""] || "CRM-контакт";
        return [
          { link: true, title: "CRM-контакты", to: { name: "CrmContacts" } },
          { link: false, title }
        ];
        // заголовок для страницы добавления CRM-контакта
      } else if (["CrmContactsAdd"].includes(this.$route.name)) {
        return [
          { link: true, title: "CRM-контакты", to: { name: "CrmContacts" } },
          { link: false, title: "Добавить CRM-контакт" }
        ];
        // заголовок для страницы списка элементов
      } else if (
        ["Node", "NodeChildren", "NodeWithParentSpec"].includes(
          this.$route.name
        )
      ) {
        return this.currentNodePathTitles;
        // заголовок для страницы добавления элемента
      } else if (this.$route.name == "NodeAdd") {
        const classAdd = this.$route.params.classAdd || null;
        const classData = this.$store.getters.getMetaClass(classAdd);
        return [
          ...this.currentNodePathTitles,
          { title: `Добавить ${classData.description}` }
        ];
        // заголовок для иных страниц (из navs)
      } else {
        const menu = this.$store.getters.getNavMenu;
        return this.recursGetNavTitles(menu);
      }
    },
    pageTitle() {
      // последний элемент массива пути названий
      if (this.currentPathTitles) {
        return [...this.currentPathTitles].pop() || { title: "" };
      } else {
        return { title: "" };
      }
    },
    pageTitlePath() {
      // весь остальной массив пути названий
      if (this.currentPathTitles) {
        return [...this.currentPathTitles].slice(0, -1);
      } else {
        return [];
      }
    },
    userName() {
      return this.$store.getters.getUserName;
    }
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
  },

  methods: {
    onMinifySidebar() {
      if (window.innerWidth >= 1264) {
        this.$store.commit("setSidebar", !this.$store.getters.getSidebar);
      } else {
        this.$emit("showSidebar");
      }
    },
    onResponsiveInverted() {
      if (window.innerWidth < 991) {
        this.responsive = true;
        this.responsiveInput = false;
      } else {
        this.responsive = false;
        this.responsiveInput = true;
      }
    },
    exit() {
      this.$store
        .dispatch("logout")
        .then(() => {
          this.$router.push({ name: "Login" });
        })
        .catch(error => {
          this.sendError(error);
        });
    }
  },
  setup() {
    // методы получения словаря и отдельной словарной статьи
    const { recursGetNavTitles } = useMenuTree();

    return {
      recursGetNavTitles
    };
  }
};
</script>
